import { Typography, Box } from "@mui/material";
import { FaRegImage, FaSignature, FaShareAlt } from "react-icons/fa";
import PropTypes from "prop-types";
import styles from "./HowItWorks.module.css";

const stepsData = [
  {
    id: "1",
    icon: <FaRegImage className={styles.icon} />,
    heading: "Create",
    text: "Upload your memorable images — your best shots, your favorite wins, or special behind-the-scenes moments."
  },
  {
    id: "2",
    icon: <FaSignature className={styles.icon} />,
    heading: "Sign",
    text: "Add your unique signature to authenticate your moment and make it a verified digital collectible."
  },
  {
    id: "3",
    icon: <FaShareAlt className={styles.icon} />,
    heading: "Share & Sell",
    text: "Share directly on social media or sell instantly via QR codes at events, TV appearances, or online."
  }
];

const HowItWorks = ({ className = "" }) => {
  return (
    <section className={[styles.howItWorksSection, className].join(" ")}>
      <Typography className={styles.howItWorksTitle} component="h1">
        How it works
      </Typography>
      <Box className={styles.stepsContainer}>
        <Box className={styles.stepsGrid}>
          {stepsData.map(step => (
            <Box key={step.id} className={styles.stepCard}>
              <Box className={styles.iconWrapper}>{step.icon}</Box>
              <Typography className={styles.stepHeading} component="h2">
                {step.heading}
              </Typography>
              <Typography className={styles.stepText}>{step.text}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </section>
  );
};

HowItWorks.propTypes = {
  className: PropTypes.string,
};

export default HowItWorks;